import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { useBrand } from '../../contexts/BrandContext';
interface HeroProps {
  variant?: 'portrait' | 'statement';
}
export function Hero({
  variant = 'portrait'
}: HeroProps) {
  const {
    brand
  } = useBrand();
  const [line1, line2] = brand.copy.heroTitle;
  if (variant === 'statement') {
    return <section className="bg-cream" data-id="element-176" data-mp="ap33vdq04av7">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-16 md:px-8 md:pb-28 md:pt-24" data-id="element-177" data-mp="apbl1ht5q2c7">
          <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-178" data-mp="5onsgrpa5dfv">{brand.tagline}</p>
          <h1 className="mt-8 max-w-5xl font-serif text-[3rem] italic leading-[0.98] text-ink md:text-[6rem]" data-id="element-179" data-mp="rfbgufvbfg7">
            {line1} {line2}
          </h1>
          <div className="mt-12 grid gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:gap-20" data-id="element-180" data-mp="1v4et0t3t6jq4">
            <p className="max-w-2xl text-lg leading-relaxed text-ink-soft md:text-xl" data-id="element-181" data-mp="1v2apic9tnmqd">
              {brand.copy.heroSubhead}
            </p>
            <HeroActions data-id="element-182" data-mp="1mw2vvglw4s8a" />
          </div>
        </div>
      </section>;
  }
  return <section className="relative isolate bg-ink" data-id="element-183" data-mp="1rvypclwyp19l">
      <img src={brand.images.hero} alt="A woman in her forties sitting at a kitchen table in lamplight, mid-thought." className="absolute inset-0 h-full w-full object-cover object-[62%_center]" data-id="element-184" data-mp="1rwqmw2a4d92i" />
      <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/85 to-ink/25" aria-hidden="true" data-id="element-185" data-mp="25mu1q86o60hx" />
      <div className="relative mx-auto max-w-shell px-6 py-24 md:px-8 md:py-36 lg:py-44" data-id="element-186" data-mp="2am6m8ma2ivhc">
        <div className="max-w-2xl" data-id="element-187" data-mp="1vxkasvnkanve">
          <p className="text-[0.6875rem] uppercase tracking-label text-blush" data-id="element-188" data-mp="1vwhiqkei6fdw">{brand.tagline}</p>
          <h1 className="mt-7 font-serif text-[3rem] italic leading-[0.98] text-cream-light md:text-[5.25rem]" data-id="element-189" data-mp="20uj1t5bxiepd">
            {line1}
            <br data-id="element-190" data-mp="2ojv6pt0840lv" />
            {line2}
          </h1>
          <p className="mt-8 max-w-xl text-lg leading-relaxed text-cream/85" data-id="element-191" data-mp="2tdg71rpah6o8">
            {brand.copy.heroSubhead}
          </p>
          <HeroActions tone="cream" data-id="element-192" data-mp="337ls6ud14kor" />
        </div>
      </div>
    </section>;
}
function HeroActions({
  tone = 'ink'
}: {
  tone?: 'ink' | 'cream';
}) {
  const isCream = tone === 'cream';
  return <div className="mt-10 flex flex-col items-start gap-5" data-id="element-193" data-mp="2u5vtd3gtijgy">
      <div className="flex flex-wrap items-center gap-4" data-id="element-194" data-mp="2p9f6sdp9od5z">
        <Link to="/symptoms" className="inline-flex items-center gap-2 rounded-brand bg-brick px-7 py-3.5 text-sm font-medium text-cream transition-colors duration-150 ease-brand hover:bg-brick-deep" data-id="element-195" data-mp="2paynu6iqys8t">
          Find out what’s happening
          <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-196" data-mp="2ak94ggv4u6tv" />
        </Link>
        <Link to="/start" className={`inline-flex items-center rounded-brand border px-7 py-3.5 text-sm font-medium transition-colors duration-150 ease-brand ${isCream ? 'border-cream/45 text-cream hover:bg-cream hover:text-ink' : 'border-ink/30 text-ink hover:border-ink hover:bg-ink hover:text-cream'}`} data-id="element-197" data-mp="26j5ugazrn50k">
          Talk to a menopause specialist
        </Link>
      </div>
      <p className={`text-sm ${isCream ? 'text-cream/70' : 'text-ink-soft'}`} data-id="element-198" data-mp="m03n3sn06jim">
        The decoder is free. No email, no account, no results held back.
      </p>
    </div>;
}